export enum Action {
  now = 0,
  prevDay = -1,
  nextDay = 1,
  checksum = -2
}



// WEBPACK FOOTER //
// ./src/app/model/action.ts